module.exports = __webpack_public_path__ + "img/galleriadfs.21bc46fa.png";